import featureClient1 from "../clients/buko/feature.json";
import featureClient2 from "../clients/happyvillebohol/feature.json";
import featureClient3 from "../clients/fitnessbohol/feature.json";
import featureClient4 from "../clients/barbellsnweights/feature.json";
import { appConfig } from "./app.config";

export const appFeatureRecord = {
  ["buko"]: featureClient1,
  ["happyvillebohol"]: featureClient2,
  ["fitnessbohol"]: featureClient3,
  ["barbellsnweights"]: featureClient4,
};
export const appFeature =
  appFeatureRecord[appConfig.client as keyof typeof appFeatureRecord];

export const getConfigValue = (key: string, defaultValue: any = null) => {
  const config = appFeature?.config as Record<string, any>;
  return config?.[key] ?? defaultValue;
};

export const isParentAndChildEnabled = (): boolean => {
  return getConfigValue("isParentAndChild", true);
};
